function IconLocation(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="22"
			viewBox="0 0 18 22"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.472168 9C0.472168 4.66934 3.64573 0.25 8.99994 0.25C14.3542 0.25 17.5277 4.66934 17.5277 9C17.5277 11.0976 16.3391 13.3892 14.9805 15.3532C13.6001 17.3488 11.9448 19.1449 10.8248 20.2784C9.81203 21.3035 8.18786 21.3035 7.17505 20.2784C6.05511 19.1449 4.39976 17.3488 3.01937 15.3532C1.66084 13.3892 0.472168 11.0976 0.472168 9ZM8.99994 1.75C4.63194 1.75 1.97217 5.33066 1.97217 9C1.97217 10.6094 2.92112 12.5744 4.25299 14.4999C5.56301 16.3937 7.15085 18.1197 8.24207 19.2242C8.66768 19.6549 9.33221 19.6549 9.75782 19.2242C10.849 18.1197 12.4369 16.3937 13.7469 14.4999C15.0788 12.5744 16.0277 10.6094 16.0277 9C16.0277 5.33066 13.368 1.75 8.99994 1.75Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 7.30555C8.18692 7.30555 7.52778 7.96468 7.52778 8.77777C7.52778 9.59086 8.18692 10.25 9 10.25C9.81309 10.25 10.4722 9.59086 10.4722 8.77777C10.4722 7.96468 9.81309 7.30555 9 7.30555ZM6.02778 8.77777C6.02778 7.13626 7.35849 5.80555 9 5.80555C10.6415 5.80555 11.9722 7.13626 11.9722 8.77777C11.9722 10.4193 10.6415 11.75 9 11.75C7.35849 11.75 6.02778 10.4193 6.02778 8.77777Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default IconLocation;
